<script>
export default {
  name: "FilterCheckbox",
  inheritAttrs: false,
  props: {
    value: {
      required: true
    },
    label: {
      required: true,
    }
  },
  methods: {
    isSelected(item) {
      return this.$attrs.modelValue.includes(item);
    }
  },
}
</script>

<template>
  <label
      :for="value"
      :class="[
          'flex items-center border py-1 px-2 rounded-md cursor-pointer',
          isSelected(value) ? 'bg-primary-50 border-primary-400 hover:bg-primary-100' : 'hover:bg-primary-50 border-surface-300'
          ]"
  >
    <Checkbox :inputId="value" :value="value" class="cursor-pointer" name="role" v-bind="$attrs"/>
    <span :class="['ml-2 cursor-pointer', isSelected(value) ? 'text-primary-600' : null]" >
      {{ label }}
    </span>
  </label>
</template>

<style scoped>

</style>